import React from 'react'
import { TextField, Typography, IconButton } from '@material-ui/core'
import { KeyboardDateTimePicker } from '@material-ui/pickers'
import { Delete } from '@material-ui/icons'
import {
  shouldValidate,
  hasError,
  shallowCompare,
  getErrorMsg,
  copyAndRemoveError,
  shouldRemoveError,
  getHoursDiff
} from '../utils'
import OverridePopover from '../components/OverridePopover'
import moment from 'moment'

export default class CellComponent extends React.Component {
  constructor(props) {
    super(props)
    
    this.onFieldChange = this.onFieldChange.bind(this)
    this.onRouteChange = this.onRouteChange.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
  }
  
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    const { row, errors, page } = this.props
    return shallowCompare(nextProps.row, row) || nextProps.errors !== errors || nextProps.page !== page
  }
  
  onFieldChange(field) {
    return (e) => {
      const { row, errors, updateRowAndErrors } = this.props
      const rowCopy = Object.assign({}, row)
      rowCopy[field] = e.target.value
      
      if (shouldRemoveError(errors, field, rowCopy)) {
        updateRowAndErrors(rowCopy, copyAndRemoveError(errors, field))
      } else if (shouldValidate(row)) {
        updateRowAndErrors(rowCopy, { fieldsWithError: [] })
      } else {
        updateRowAndErrors(rowCopy, errors)
      }
    }
  }
  
  onRouteChange({ target: { value } }) {
    const { row, updateRowAndErrors, errors } = this.props

    const rowCopy = Object.assign({}, row)
    const cleansedValue = value.replace(/[^0-9.]+/g, '')
    const intValue = cleansedValue && parseInt(cleansedValue)
    const foundRouteInfo = this.props.routeInfo.find(({ PropAgr_ID }) => PropAgr_ID === intValue)
    
    rowCopy.routeId = intValue
    rowCopy.extraData = foundRouteInfo
    rowCopy.propNameAddress = foundRouteInfo && foundRouteInfo.PropName
    rowCopy.address = foundRouteInfo && foundRouteInfo.Address
    rowCopy.vendorOverride = void 0
    
    if (!rowCopy.crewPercent) {
      rowCopy.crewPercent = 100
      rowCopy.snowDepth = 2
    }

    if (!intValue) {
      rowCopy.crewPercent = ''
      rowCopy.snowDepth = ''
    }

    if (!rowCopy.snowDepth) {
      rowCopy.snowDepth = 2
    }
    
    if (shouldRemoveError(errors, 'routeId', rowCopy)) {
      updateRowAndErrors(rowCopy, copyAndRemoveError(errors, 'routeId'))
    } else if (shouldValidate(row)) {
      updateRowAndErrors(rowCopy, { fieldsWithError: [] })
    } else {
      updateRowAndErrors(rowCopy, errors)
    }
  }
  
  dateLabelFunc(field) {
    return (date) => {
      return field ? moment(date).format('MM/DD/YY HH:mm') : ''
    }
  }
  
  handleDateChange(field) {
    return (value) => {
      const { row, updateRowAndErrors, errors } = this.props
      const rowCopy = Object.assign({}, row)
      rowCopy[field] = value && moment(value).format('MM/DD/YY HH:mm')
      
      if (moment(value).isValid()) {
        row.dateEndRef.focus()
      }
      
      if (shouldRemoveError(errors, field, rowCopy)) {
        updateRowAndErrors(rowCopy, copyAndRemoveError(errors, field))
      } else if (shouldValidate(row)) {
        updateRowAndErrors(rowCopy, { fieldsWithError: [] })
      } else {
        updateRowAndErrors(rowCopy, errors)
      }
    }
  }
  
  render() {
    const { row, col, idx, errors, clearRow, onRouteBlur, readOnly, canDelete } = this.props
    const isError = hasError(errors, col.field)
    const errorMsg = isError ? getErrorMsg(col.field) : null
    
    if (col.field === 'crewPercent' || col.field === 'quantityMaterial' || col.field === 'plowsOrTechs') {
      const width = 95
      return (
        <div style={{ display: 'flex', flexDirection: 'row', width }}>
          <TextField
            error={isError}
            label={errorMsg}
            disabled={!!(col.field === 'quantityMaterial' && row.extraData && !row.extraData.Stocking_Units) || readOnly}
            fullWidth
            type="number"
            inputProps={{ min: 0, max: col.field === 'crewPercent' ? 100 : null }}
            value={row[col.field]}
            onChange={this.onFieldChange(col.field)}
          />
          {row.extraData && col.field === 'plowsOrTechs' ?
            <span style={{ marginTop: 5 }}>{row.extraData.Q_Code === 'P' ? 'Techs' : 'Plows'}</span> : null}
          {row.extraData && col.field === 'quantityMaterial' ?
            <span style={{ marginTop: 5 }}>{row.extraData.Stocking_Units}</span> : null}
        </div>
      )
    }
    
    switch (col.field) {
    case 'rowNum':
      return idx + 1
    
    case 'routeId':
      return (
        <div style={{ display: 'flex', flexDirection: 'row', width: 150 }}>
          <TextField
            inputRef={ref => row.ref = ref}
            style={{ width: 100 }}
            error={isError}
            label={errorMsg}
            fullWidth
            value={row[col.field]}
            onBlur={onRouteBlur}
            onChange={this.onRouteChange}
            disabled={readOnly}
          />
          {
            row.crewOverride || row.vendorOverride ? (
              <OverridePopover
                onClick={onRouteBlur}
                crewOverride={row.crewOverride}
                vendorOverride={row.vendorOverride}
              />
            ) : null
          }
        </div>
      )
    
    case 'propNameAddress':
      return <Typography style={{ width: 150 }}>{row.propNameAddress}</Typography>
    
    case 'address':
      return <Typography style={{ width: 150 }}>{row.address}</Typography>

    case 'dateTimeStart':
      return (
        <KeyboardDateTimePicker
          style={{ width: 170 }}
          error={isError}
          helperText={errorMsg}
          labelFunc={this.dateLabelFunc(row[col.field])}
          value={row[col.field]}
          placeholder='mm/dd/yy 23:59'
          ampm={false}
          format="MM/dd/yy HH:mm"
          onChange={this.handleDateChange(col.field)}
          InputProps={{
            inputRef: ref => row.dateRef = ref
          }}
          InputAdornmentProps={{ style: { display: 'none' } }}
          disabled={readOnly}
        />
      )
    
    case 'dateTimeEnd':
      return (
        <KeyboardDateTimePicker
          style={{ width: 170 }}
          error={isError}
          helperText={errorMsg}
          invalidLabel={errorMsg}
          labelFunc={this.dateLabelFunc(row[col.field])}
          value={row[col.field]}
          placeholder='mm/dd/yy 23:59'
          ampm={false}
          format="MM/dd/yy HH:mm"
          strictCompareDates={true}
          minDate={moment(row.dateTimeStart).format('yyyy-mm-dd') || ''}
          minDateMessage="End date should not be before start date"
          onChange={this.handleDateChange(col.field)}
          InputProps={{
            inputRef: ref => row.dateEndRef = ref
          }}
          InputAdornmentProps={{ style: { display: 'none' } }}
          disabled={readOnly}
        />
      )
    
    case 'code':
      return <Typography style={{ width: 94 }}>{row.extraData && row.extraData.Prod_CrewDesc}</Typography>
    
    case 'totalHours':
      return (
        <Typography style={{ width: 85 }}>
          {getHoursDiff(row.dateTimeStart, row.dateTimeEnd, row.plowsOrTechs).toFixed(2) !== '0.00' ? 
            getHoursDiff(row.dateTimeStart, row.dateTimeEnd, row.plowsOrTechs).toFixed(2) : null}
        </Typography>
      )

    case 'snowDepth':
      return <Typography style={{ width: 75 }}>{row.snowDepth}</Typography>

    case 'notes':
      return (
        <TextField
          multiline
          fullWidth
          value={row[col.field]}
          onChange={this.onFieldChange(col.field)}
          disabled={readOnly}
        />
      )
    
    case 'clearRow':
      return (
        canDelete ? (
          <IconButton
            onClick={clearRow}
            disabled={readOnly}
          >
            <Delete/>
          </IconButton>
        ) : null
      )
    
    default:
      return <TextField fullWidth value={row[col.field]} disabled={readOnly}/>
    }
  }
}
